export default function initFilterToggle() {
  const isPresent = document.querySelector("[data-toggle-filters]");
  if (!isPresent) {
    return;
  }

  const toggleButtons = document.querySelectorAll("[data-toggle-filters]");
  const target = document.querySelector("[data-toggle-filters-target]");
  const closeButtons = document.querySelectorAll("[data-close-filters]");

  toggleButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      document.body.classList.add("filters-active");
      target.classList.add("is-visible");
      button.classList.add("active");
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      document.body.classList.remove("filters-active");
      target.classList.remove("is-visible");
      toggleButtons.forEach(function (button) {
        button.classList.remove("active");
      });
    });
  });
}
